import Api from 'api'

const config = {
  baseURL: '/api/app/v1/banners',
}
const api = new Api(config)

api.fetchBanners = ({ ...rest }) => api.get(``, { ...rest })

export default api
